import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TrackingPageDefaultValues } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/tracking-page.models';
import { Shop } from '@services/shops/shop.model';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import { ITrackingPage } from '@pdqdev/pdq-shared/dist/interfaces/shopPlugin/ITrackingPage';

@Component({
  selector: 'tracking-page-search-preview',
  templateUrl: './tracking-page-search-preview.component.html',
  styleUrls: ['./tracking-page-search-preview.component.scss', '../../tracking-page.component.scss'],
  standalone: false,
})
export class TrackingPageSearchPreviewComponent implements OnInit, OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() shop: Shop;
  @Input() alignment: 'left' | 'center' | 'right' = 'left';
  accentColor: string = TrackingPageDefaultValues.settings.accentColor;
  searchPage: ShopPlugin.TrackingPage.SearchPageWidget;

  title: string = TrackingPageDefaultValues.settings.searchPage.title;
  inputPlaceholder: string = TrackingPageDefaultValues.settings.searchPage.inputPlaceholder;
  verifyByTrackingOrOrderNumber: boolean = TrackingPageDefaultValues.settings.searchPage.verifyByTrackingOrOrderNumber;
  verificationStrategy: ITrackingPage.VerificationStrategy = TrackingPageDefaultValues.settings.searchPage
    .verificationStrategy as ITrackingPage.VerificationStrategy;
  buttonText: string = TrackingPageDefaultValues.settings.searchPage.buttonText;
  titleAlignment: string = TrackingPageDefaultValues.settings.searchPage.titleAlignment;
  emailPlaceholder: string = TrackingPageDefaultValues.settings.searchPage.emailPlaceholder;
  phonePlaceholder: string = TrackingPageDefaultValues.settings.searchPage.phonePlaceholder;
  VerificationStrategy = ITrackingPage.VerificationStrategy;

  constructor() {}

  ngOnInit(): void {}

  initPreviewFieldsValueChanges() {
    this.formGroup.valueChanges.subscribe((values) => {
      this.accentColor = values.settings.accentColor;
      this.title = values.settings.searchPage?.title;
      this.inputPlaceholder = values.settings.searchPage?.inputPlaceholder;
      this.buttonText = values.settings.searchPage?.buttonText;
      this.titleAlignment = values.settings.searchPage?.titleAlignment;
      this.verifyByTrackingOrOrderNumber = values.settings.searchPage?.verifyByTrackingOrOrderNumber;
      this.verificationStrategy = values.settings.searchPage?.verificationStrategy;
      this.emailPlaceholder = values.settings.searchPage?.emailPlaceholder;
      this.phonePlaceholder = values.settings.searchPage?.phonePlaceholder;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formGroup) {
      this.initPreviewFieldsValueChanges();
    }
  }
}
